module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEtSURBVHgBrVFBTsMwEJw1ASJxMe2BIA7kCeEFiBcA1yoS7QuAFwA/gBcEpKYc4QeEH9AXUE6EC/ExVRsvdhMoKuEQwUi27Nmd8a4X+G/0W5snZmXx+sZdXVzUkbfS85n5eKJ5h0n4A+ntLuY4dovbXpcZJshqSdOVFnggjfOeSkfm1TpvOJH0JXMelVdCIahrDO5Dld5UOf4Y+fCH0EUui2+EKVFNGRfzO5Jl4Wb9llf1xped97dTsv0UAs9zJZIwS/fwC+yHQSMQaIBYbgW2olC9vjhNhBDFPgFJWXIDMOhAaFzXC4kD2/ciXc1WdlT6OBPmcJX5udGXK5Oycxy0vaNPLpJSGu6MqCxz5l8GPH/VwbY9j6f5cAVrPpOO7OtVmjKOTxPOD3tKKfwFH9VCe4JBUGFoAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/f5.png
// module id = v+G3
// module chunks = 1